import DescriptionDetails from "components/DescriptionDetails";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import MetaInfoListItem from "components/MetaInfoList/Item";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";

import FieldsGroup from "../FieldsGroup";
import { ScanDetailsDrawerItem } from "../types";

type ScanDetailsTabProps = {
  scan: ScanDetailsDrawerItem;
  onOpenFullDescription: () => void;
};

const ScanDetailsTab = ({ scan, onOpenFullDescription }: ScanDetailsTabProps) => (
  <FieldsGroup>
    <FormFieldViewText label="ID" value={scan.id} withCopy noMargin />
    <FormFieldViewText label="Name" value={scan.name} noMargin />

    <FormField label="Space" noMargin>
      <SpacePath variant="expandable" spaceId={scan.space.id} fallbackName={scan.space.name} />
    </FormField>

    <FormField label="Labels" noMargin>
      {scan.labels.length > 0 ? (
        <TagsList tags={scan.labels} alwaysExpanded />
      ) : (
        <Typography tag="span" variant="p-body3" color="disabled">
          None
        </Typography>
      )}
    </FormField>

    <DescriptionDetails
      description={scan.description}
      onOpenFullDescription={onOpenFullDescription}
      noMargin
    />

    {scan.workerPoolName && (
      <FormField label="Worker pool" noMargin>
        <MetaInfoListItem linkText={scan.workerPoolName} href={`/worker-pool/${scan.workerPool}`} />
      </FormField>
    )}

    <FormFieldTimestamp label="Created at" timestamp={scan.createdAt} noMargin />
    <FormFieldTimestamp label="Last updated" timestamp={scan.updatedAt} noMargin />

    {scan.latestRun && (
      <FormFieldTimestamp label="Last scan" timestamp={scan.latestRun.stateChangedAt} noMargin />
    )}
  </FieldsGroup>
);

export default ScanDetailsTab;
